import { render, staticRenderFns } from "./float-customer-service.vue?vue&type=template&id=bd5994a8&scoped=true"
import script from "./float-customer-service.vue?vue&type=script&lang=js"
export * from "./float-customer-service.vue?vue&type=script&lang=js"
import style0 from "./float-customer-service.vue?vue&type=style&index=0&id=bd5994a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5994a8",
  null
  
)

export default component.exports